import api from '@/api/user'

export default {
    state: {
        userInfo: localStorage["userInfo"] ? JSON.parse(localStorage["userInfo"]) : null,
        permission: null, //权限
        pushId: null, //极光获取回来的installationId，
    },
    mutations: {
        CHANGE_Token: (state, userInfo) => {
            state.userInfo = userInfo
        },
        //更新权限
        UPDATE_PERMISSION(state, newVal) {
            let obj = {};
            newVal.map(val => {
                const key = val.slice(0, -1);
                const value = val.slice(-1);
                obj[key] = value;
            });
            state.permission = obj;
        },
        UPDATE_PUSHId(state, newVal) {
            // console.log(newVal)
            newVal ? state.pushId = newVal : null;
        },
    },
    actions: {
        changeToken({ commit }, userInfo) {
            if (userInfo) {
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
            } else {
                localStorage.removeItem('userInfo');
            }
            commit('CHANGE_Token', userInfo)
        },

        updatedPermission({ commit, state }) {
            return new Promise((resolve, reject) => {
                api.getPermissions().then(res => {
                    if (res.code === 0) {
                        commit('UPDATE_PERMISSION', res.data);
                        resolve();
                    }
                }).catch(err => {
                    reject();
                })
            })
        },
        upDatePushId({ commit }, pushId) {
            commit('UPDATE_PUSHId', pushId)
        }

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/permission.js